import React from 'react';

interface Child {
  id: string;
  name: string;
  age: number;
  avatar_color: string;
}

interface ChildSelectorProps {
  children: Child[];
  selectedChild: string | null;
  onSelectChild: (childId: string) => void;
  isDarkMode?: boolean;
}

export function ChildSelector({ children, selectedChild, onSelectChild, isDarkMode = false }: ChildSelectorProps) {
  if (children.length === 0) return null;

  return (
    <div>
      <h2 className={`text-xl font-semibold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
        Select Child
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {children.map((child) => (
          <button
            key={child.id}
            onClick={() => onSelectChild(child.id)}
            className={`p-4 rounded-xl border-2 text-left transition-all ${
              selectedChild === child.id
                ? isDarkMode
                  ? 'border-purple-400 bg-purple-900/50'
                  : 'border-purple-500 bg-purple-50'
                : isDarkMode
                ? 'border-gray-600 hover:border-gray-500 bg-gray-800'
                : 'border-gray-200 hover:border-gray-300 bg-white'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div
                className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold"
                style={{ backgroundColor: child.avatar_color }}
              >
                {child.name.charAt(0).toUpperCase()}
              </div>
              <div>
                <div className={`font-semibold ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                  {child.name}
                </div>
                <div className={`text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                  Age {child.age}
                </div>
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
